<template>
  <div :id="'a' + chatItem.time">
    <div
      class="segmentations"
      v-for="item in segmentationTime"
      :key="item.idtimes"
    >
      <div class="line" v-if="showLine(item.idtimes)">
        <div></div>
        <span>{{ item.date }}</span>
        <div></div>
      </div>
    </div>
    <div :class="chatDirection">
      <div :class="['msg', `msg-${chatDirection}`]" ref="msgContent">
        <div
          :class="
            chatItem.type === 'custom'
              ? 'custom-message-wrapper'
              : `message-wrapper message-wrapper-${chatDirection}`
          "
          :id="chatItem.type === 'image' || 'audio' ? 'radius' : ''"
          :ref="chatDirectionRight ? 'msgWrapper' : ''"
          :style="
            chatItem.type === 'image'
              ? chatDirectionRight
                ? 'background: none; padding: 0;'
                : 'background-color:#f1f3f5; padding: 0;'
              : chatItem.type === 'audio'
              ? 'cursor: pointer;'
              : ''
          "
          @click.stop="handleAudio"
        >
          <div class="message" v-if="chatItem.type === 'custom'">
            <custom-item :content="customContent"></custom-item>
          </div>
          <template v-if="chatItem.type === 'text'">
            <div
              class="message message-text"
              v-text="chatItem.text.trim()"
              :ref="chatDirectionRight ? 'msgTextR' : 'msgTextL'"
            ></div>
            <div class="readMore" v-if="readMore" @click="handleReadMore">
              <span :style="{
                color: chatDirectionRight ? '#fff' : '#4066d4'
              }" :ref="chatDirectionRight ? 'readInfoR' : 'readInfoL'"> Read More</span>
              <img
                :ref="chatDirectionRight ? 'downRowR' : 'downRowL'"
                :src="chatDirectionRight ? downRowIn : downRowOut"
                alt=""
              />
            </div>
          </template>

          <div
            class="message msgImg"
            v-if="chatItem.type === 'image'"
            :style="chatDirectionRight ? '' 
            : 'background: none; padding: 0;'"
          >
            <img
              class="imgs"
              :src="chatItem.blob || chatItem.file.url"
              :ref="chatDirectionRight ? 'rightImg' : 'leftImg'"
              alt=""
              @load="loadImg"
              @mouseover="imgOvers"
              @mouseleave="imgLeave"
              @click="imgVisible = true"
            />
            <div class="downloadNor" v-show="isDownImg">
              <a
                @click.stop="
                  downloadByBlob(chatItem.file.url, chatItem.file.name)
                "
              >
                <img
                  @mouseover="imgOver"
                  src="@/assets/img/im-icon/download-nor.svg"
                  alt=""
                />
              </a>
            </div>
          </div>
          <div
            class="message"
            v-if="chatItem.type === 'audio'"
            @click="handleAudio"
          >
            <div
              @click="handleAudio"
              class="audio"
              :style="dynamicStyle(chatItem)"
            >
              <img
                :src="chatDirectionRight ? startRight : startLeft"
                alt=""
                v-if="!isContinuePlaying(isTurnOnAudioList, this.getTimeMethods(chatItem.file.mp3Url), 'show')"
              />
              <img
                :src="chatDirectionRight ? pauseRight : pauseLeft"
                v-else
                alt=""
              />
              <audio
                ref="mp3Audio"
                :src="chatItem.file.mp3Url"
                controls="controls"
                id="audio"
                v-show="false"
              ></audio>
              <p>
               {{isContinuePlaying(isTurnOnAudioList, this.getTimeMethods(chatItem.file.mp3Url), 'show') ? calcAudioTime : defaultTime()}}
              </p>
            </div>
          </div>
        </div>
        <span class="loding" v-if="chatItem.status === 'sending' && chatDirectionRight">
          <img src="@/assets/img/chat-icon/loading.svg" alt="" />
        </span>
      </div>
      <div :class="[`time-${chatDirection}`]" v-if="isContinuous">
        <p>
          <span class="failedStatus" v-if="chatItem.status === 'fail' && chatDirectionRight" ref="msgStatus">
            <img src="@/assets/img/chat-icon/failed2.svg" alt="">
            <span class="failedStatusWord">Failed to send</span>
            <span class="resendWord" @click="resendMsg">Resend</span>
          </span>
          <span
            :ref="chatDirectionRight ? 'timeR' : ''"
            v-text="
              Yesterday(chatItem.time) ? 'Yesterday' : time(chatItem.time)
            "
          >
          </span>
        </p>
      </div>
    </div>

    <template v-if="chatItem.type === 'image'">
      <dialog-img
        :visible="imgVisible"
        :imgUrl="chatItem.blob || chatItem.file.url"
        @close="imgVisible = false"
      />
    </template>
  </div>
</template>

<script>
import chatMixins from "@/im/components/chat-content-panel/chat-mixins";

export default {
  mixins: [chatMixins],
  mounted() {
    this.$nextTick(() => {
      if (this.chatItem.status === 'fail' && this.chatDirectionRight) {
        setTimeout(() => {
          let msgW = this.$refs.msgWrapper.getBoundingClientRect().width;
          let timeWidth = this.$refs.timeR.getBoundingClientRect().width;
          const w = 152 + 10;
          if (msgW > timeWidth + w) {
            this.$refs.msgStatus.style.marginRight = msgW - timeWidth - w + 10 + 'px';
          }
        })
      }
    })

    this.srollBottom(true);
  },
  methods: {
    defaultTime() {
      this.audioTime = Math.round(this.duration/1000) >= 60
                    ? 60000
                    : this.duration;
      const _time = Math.round(this.duration/1000) >= 60
                    ? 60000
                    : this.duration;
      const audioTime = Math.round(_time / 1000);
      if (audioTime >= 60) {
        return '1:00';
      }
      const minutes = Math.floor(audioTime / 60);
      const seconds = audioTime % 60;

      const formattedMinutes = minutes.toString();
      const formattedSeconds = seconds < 10 ? '0' + seconds.toString() : seconds.toString();
      return `${formattedMinutes}:${formattedSeconds}`;
    },
    /**
     * 图片加载判断展示
     */
    loadImg() {
      if (this.$refs.rightImg) {
        let width = this.$refs.rightImg.getBoundingClientRect().width;
        let height = this.$refs.rightImg.getBoundingClientRect().height;
        let w = "auto";
        let h = "auto";
        if (width < 120 && height < 120) {
          w = width;
          h = height;
        } else {
          if (width - height <= 30 || width - height >= -30) {
              w = 120;
              this.$refs.rightImg.style.objectFit = "cover";
            } else {
            if (width > height) {
              w = 180;
              this.$refs.rightImg.style.objectFit = "scale-down";
            } else {
              h = 260;
              w = 120;
              this.$refs.rightImg.style.objectFit = "cover";
            }
          }
        }
        this.$refs.rightImg.style.width = isNaN(w) ? w : `${w}px`;
        this.$refs.rightImg.style.height = isNaN(h) ? h : `${h}px`;
      }
      if (this.$refs.leftImg) {
        let width = this.$refs.leftImg.getBoundingClientRect().width;
        let height = this.$refs.leftImg.getBoundingClientRect().height;
        let w = "auto";
        let h = "auto";
        if (width < 180 && height < 180) {
          w = width;
          h = height;
        } else {
          if (width - height <= 30 || width - height >= -30) {
              w = 120;
              this.$refs.leftImg.style.objectFit = "cover";
            } else {
            if (width > height) {
              w = 240;
              this.$refs.leftImg.style.objectFit = "scale-down";
            } else {
              h = 240;
              this.$refs.leftImg.style.objectFit = "cover";
            }
          }
        }

        this.$refs.leftImg.style.width = isNaN(w) ? w : `${w}px`;
        this.$refs.leftImg.style.height = isNaN(h) ? h : `${h}px`;
      }
    },
  },
  watch: {
    segmentationTime() {
      this.$nextTick(() => {
        if (this.$props.chatItem.status === 'fail') {
          this.$refs.resend.style.display = 'none';
          setTimeout(() => {
            let msgW = this.$refs.msgWrapper.getBoundingClientRect().width;
            let timerW = this.$refs.timeR.getBoundingClientRect().width;
            let msgS = this.$refs.msgStatus.getBoundingClientRect().width;

            if (msgW > timerW + msgS + 66.06) {
              this.$refs.resend.style.left = '16px';
            } 
            else {
              this.$refs.resend.style.left = `-${timerW + msgS + 20 - this.$refs.msgWrapper.children[0].getBoundingClientRect().width}px`;
            }
            this.$refs.resend.style.display = 'block';
            }, 300)
        }
      })
    }
  },
};
</script>
<style lang="scss" scoped>
.chat-wrapper {
  margin-top: 8px;
  // padding: 5px 16px;
  .segmentations {
    .line {
      display: flex;
      align-items: center;
      margin: 8px 0;
      justify-content: space-between;

      div {
        flex: 1;
        height: 1px;
        background-color: #e5e6ea;

        &:nth-of-type(1) {
          margin-right: 16px;
        }

        &:nth-of-type(2) {
          margin-left: 16px;
        }
      }
      span {
        text-align: center;
        font-family: OpenSans;
        font-size: 14px;
        color: #7f8596;
      }
    }
  }
}
.audio {
  border: none;
  display: flex;
  height: 16px;
  align-items: center;
  justify-content: space-between;
  img {
    width: 24px;
    height: 24px;
  }
}
.left {
  display: flex;
  flex-direction: column;

  .time-left {
    margin-bottom: 8px;
    margin-top: 6px;
    font-size: 12px;

    p {
      text-align: left;
      color: #a1afc4;
      span {
        font-size: 12px;
      }
    }
  }
}
.right {
  display: flex;
  justify-content: center;
  flex-direction: column;

  .time-right {
    height: 16px;
    margin-bottom: 8px;
    margin-top: 6px;
    font-size: 12px;

    p {
      height: auto;
      text-align: right;
      color: #a1afc4;
      height: 16px;
      display: flex;
      align-items: flex-end;
      justify-content: flex-end;
      .failedStatus {
        margin-right: 10px;
        display: flex;
        align-items: center;
        width: 152px;
        > img {
          width: 13.33px;
          height: 13.33px;
          
        }
        .failedStatusWord {
          width: 80px;
          margin-left: 5.33px;
          color: #cf1322;
          font-family: OpenSans;
          font-weight: 500;
          font-size: 12px;
          line-height: 16px;
        }
        .resendWord {
          width: 42px;
          margin-left: 10px;
          color: #4066d4;
          font-family: OpenSans;
          font-weight: 500;
          font-size: 12px;
          line-height: 16px;
          cursor: pointer;
        }
      }
      .status {
        height: 16px;
        margin-right: 6px;

        // div {
        //   display: flex;
        // }

        img {
          vertical-align: middle;
        }

        span {
          display: inline-block;
          height: 16px;
          font-weight: normal;
        }
      }

      span {
        height: 16px;
        font-weight: normal;
      }
    }
  }
}
.msg {
  display: flex;
  align-items: center;
  margin-top: 8px;

  .message-wrapper {
    min-width: 40px;
    position: relative;
    transition: height 0.3s;
    min-height: 40px;
    display: flex;
    justify-content: center;
    max-width: 240px;
    flex-wrap: wrap;
    padding: 10px 16px;
    box-sizing: border-box;

    .readMore {
      width: 100%;
      height: 20px;
      margin-top: 8px;
      display: flex;
      align-items: center;

      span {
        font-size: 12px;
        color: #4066d4;
        cursor: pointer;
        line-height: 20px;
        font-weight: bold;
        padding-right: 4px;
      }

      img {
        width: 16px;
        height: 16px;
        transition: transform 0.3s;
        cursor: pointer;
      }
    }

    .message {
      // margin: 10px;
      box-sizing: border-box;
      font-size: 14px;
      display: flex;
      // max-width: 89px;
      // height: 50px;
      overflow: hidden;
      justify-content: center;
      align-items: center;
      line-height: 1.43;
      position: relative;

      .downloadNor {
        cursor: pointer;
        width: 22px;
        height: 22px;
        bottom: 14px;
        right: 8px;
        display: flex;
        text-align: center;
        align-items: center;
        line-height: 22px;
        // display: inline-block;
        justify-content: center;
        border-radius: 50%;
        position: absolute;
        background-color: rgba(0, 0, 0, 0.31);
        align-items: center;
        a {
          height: auto;
          height: 16px;
          display: block;
          border-radius: 50%;
          display: flex;
          img {
            width: 16px;
            height: 16px;
          }
        }
      }
    }

    .message-text {
      font-weight: 500;
      transition: height 0.3s;
      white-space: pre-wrap;
      word-wrap: break-word;
      word-break: break-all;
      display: -webkit-box;
      -webkit-line-clamp: 5;
      overflow: hidden;
      /*! autoprefixer: ignore next */
      -webkit-box-orient: vertical;
    }

    .resendMsg {
      position: absolute;
      bottom: -22px;
      left: 16px;
      color: #4066d4;
      font-size: 12px;
      height: 16px;
      line-height: 16px;
      cursor: pointer;
    }
  }
  .loding,
  .sendFailed {
    margin-right: 12px;
    line-height: auto;
  }
  .sendFailed > img {
    cursor: pointer;
  }
  .loding {
    > img {
      animation: rotate 1s linear infinite;
    }
  }
  @keyframes rotate {
    0% {
      transform: rotate(360deg);
    }
    100% {
      transform: rotate(0deg);
    }
  }
  .message-wrapper-left {
    color: #000;
    background-color: #fff;
    border-radius: 20px 20px 20px 0;

    .msgImg {
      border-radius: 20px 20px 20px 0;
    }

    img {
      border-radius: 20px 20px 20px 0;
    }
  }
  .message-wrapper-right {
    color: #fff;
    background-color: #089c86;
    border-radius: 20px 20px 0 20px;

    .msgImg {
      border-radius: 20px 20px 0 20px;
    }

    img {
      border-radius: 20px 20px 0 20px;
    }
  }
  .imgs {
    flex: auto;
    height: 120px;
    width: 120px;
    border-radius: 8px;
    background: url("~@/assets/img/im-icon/load-img.svg") no-repeat center 50%;
    background-size: 22.75px 19.5px;
  }
}
.msg-right {
  position: relative;
  flex-direction: row-reverse;
  .downloadNor {
    cursor: pointer;
    width: 22px;
    height: 22px;
    display: flex;
    align-items: center;
    justify-content: center;
    right: 100px;
    bottom: 14px;
    border-radius: 50%;
    position: absolute;
    background-color: rgba(0, 0, 0, 0.31);
    img {
      width: 80px;
      height: 40px;
    }
    // a {
    //   height: auto;
    //   height: 16px;
    //   display: block;
    //   border-radius: 50%;
    //     img {
    //       width: 16px;
    //       height: 16px;
    //     }
    //     .downImg {
    //       width: 0;
    //       height: 0;
    //     }
    // }
  }

  .custom-message-wrapper {
    border-radius: 8px 8px 0 8px !important;

    .message {
      border-radius: 8px 8px 0 8px;
    }
  }
}
.msg-left {
  flex-direction: row;

  .custom-message-wrapper {
    margin-left: 10px;
    border-radius: 8px 8px 8px 0px !important;

    .message {
      border-radius: 8px 8px 8px 0px;
    }
  }
}

.msgImg {
  border: 1px solid #c8cdda;
  max-width: 260px;
  max-height: 260px;
}

.custom-message-wrapper {
  padding: 1px !important;
  background: #c8cdda !important;
  overflow: hidden !important;

  .message {
    width: 230px;
    height: 120px;
    // margin: 0px 4px 10px 0px;
    padding: 12px;
    border-radius: 8px;
    background-color: #ffffff;
  }
}
</style>
